<!-- Main landing page for the application-->
<!-- Loader-->

<!-- end of loader -->
<ng-container>
<div style="overflow-x: clip;" >
<div style="margin:0px;padding: 0px;">
	<div class="row">
		<div class="col-sm-12">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style="height: 365px;">
			  <defs>
                <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color:#600;stop-opacity:1" />
                  <stop offset="90%" style="stop-color:#006;stop-opacity:1" />
                </linearGradient>
            </defs>
			  <path fill="url(#grad3)"  fill-opacity="1" d="M0,160L60,154.7C120,149,240,139,360,138.7C480,139,600,149,720,165.3C840,181,960,203,1080,224C1200,245,1320,267,1380,277.3L1440,288L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
			</svg>
			<div class="contact-card">
			<div style="text-align: center;margin-bottom: 30px;">
			    <hr class="break-hr">
			    <h3 class="contact-head"> Contact Us </h3>
			    <hr class="break-hr">
			</div>
			<h2 class="c-header">SNAM ALLOYS PRIVATE LIMITED</h2>
			<p class="contact-content">
                C/O SNAM ALLOYS PRIVATE LIMITED<br/>#21 E INDUSTRIAL ESTATE,<br/>ATTIBELE ANEKAL TALUK,<br/>BANGALORE, KARNATAKA 562107
            </p>
            <div class="social-button" >  
                <a href="mailto:snamthermal@snam.co.in" target="blank" class="social-margin">
                  <div class="social-icon gmail">
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                  </div> 
                </a>
            </div>
		</div>
		</div>
		
	</div>
</div>
</div>
</ng-container>

<!-- end of form for sign up-->
<style>
	.contact-card{
		z-index: auto;
	}
</style>